/* eslint-disable */
import React, { useEffect } from 'react';
import {
    TextField,
    Paper,
    RadioGroup,
    Radio,
    FormControlLabel,
    Autocomplete,
    Box,
    Button,
    Divider,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import CustomDialog from '../dialog/dialog';
import ButtonContainer from '../buttoncontainer/buttonContainer';
import Helper from '../../utility/helper';
import { useState, Downgraded, createState } from '@hookstate/core';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Typography from '@mui/material/Typography';
 import ParticipantUserCheckList from './participantUserCheckList';
 import ParticipantUserAddedCheckList from './participantUserAddedCheckList';
 
const useStyles = makeStyles({
    dialogContentRoot: {
        // maxHeight: 400,
        // overflowY: 'hidden',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
});

 
const ParticipantUserListDialog = (props) => {
    const classes = useStyles();
    const tags = useState(null);
     const roles = useState(null);
    const userRole = useState(null);
    const selectedUsers = useState([]);
    const rightSelectedUsers = useState([]);
    const selectedTags = useState([]);
    const eventInfo = useState(null);
    const userInfo = useState(null);
    const finalEventParticipants = useState([]);
    const eventData = useState(null);
    const [search, setSearch] = React.useState('');
    const selected = useState([]);
    const rightSelected = useState([]);    
    const [inviteParticipants, setInviteParticipants] = React.useState([]);
    const [leftParticipants, setLeftParticipants] = React.useState([]);
    const [rightParticipants, setRightParticipants] = React.useState([]);
    const [rightDefaultParticipants, setRightDefaultParticipants] = React.useState([]);
    const [addsearch, setAddSearch] = React.useState('');
    const [resetCheckBox, setResetCheckBox] = React.useState(false);
    const [sortOrder, setSortOrder] = React.useState('user');

    useEffect(() => {
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');

        eventInfo.set(userEventInfo);
        userInfo.set(guserInfo);

        if (!props.invitationList) {
            setRolesNTags(userEventInfo.eventID);
        } 

        const eventInfoStorage = Helper.getStorage('eventInfo');
        if (
            eventData.get() === null ||
            (eventData.get() && eventData.eventID.value !== eventInfoStorage.eventID)
        ) {
            eventData.set(eventInfoStorage);
        }   
        return () => {
        // reset();    
        }      
    }, []);

    const reset = () => {
        setLeftParticipants([]);
        setRightParticipants([]);
        selectedUsers.set([]);
        rightSelected.set([]);
    }

    useEffect(() => {
        const { eventParticipants, users } = props;

        if (eventParticipants && eventParticipants.length > 0) {
            const finalParticipants = eventParticipants.map((item) => item);
            finalEventParticipants.set(finalParticipants);

            const leftArrow = users.filter((i) => eventParticipants.every((j) => i.userID !== j.userID));
            // setLeftParticipants(() => leftArrow);
            setLeftParticipants(() => leftArrow.sort((a, b) => a.lastName.localeCompare(b.lastName)));
        }

        if (users && eventParticipants.length === 0) {
            setInviteParticipants(() => users);
            setLeftParticipants(() => users);
        }
    }, [props.eventParticipants, props.users]); 

    const setRolesNTags = async (eventID) => {
        const rolesdata = ApiHelper.get(APIURLConstants.GET_ROLES(eventID));
        const tagsdata = ApiHelper.get(APIURLConstants.GET_TAGS(eventID));

        await Promise.all([rolesdata, tagsdata]).then((data) => {
            Helper.setStorage('userRoles', data[0].data);
            Helper.setStorage('userTags', data[1].data);
            const rolesd = data[0].data.filter((item) => item.status == 1);
            const tagsd = data[1].data.filter((item) => item.status == 1);
            tags.set(tagsd);
            roles.set(rolesd);
        });
    };

    const checkSelectedUsers = (value) => {
        selectedUsers.set(value);
        onAddParticipant()
    };
    const rightCheckSelectedUsers = (value) => {       
        rightSelectedUsers.set(value);
    }; 
    
    const onAddParticipant = () => {
        // if (selectedUsers.attach(Downgraded).get().length == 0) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please select participants',
        //     });
        //     return false
        // } else {
            const deletedData = leftParticipants.filter((val) => selectedUsers.attach(Downgraded).get().includes(val.userID))
            let data = leftParticipants.filter(item => !selectedUsers.attach(Downgraded).get().includes(item.userID));
            setLeftParticipants(data)
            if (search && search.length > 0) {
                let searchData = inviteParticipants.filter(item => !selectedUsers.attach(Downgraded).get().includes(item.userID));
                setInviteParticipants(searchData)
            }
            setResetCheckBox(true)
            setSearch('')
            const newRightPart = deletedData.concat(rightDefaultParticipants)
            setRightDefaultParticipants(newRightPart)
            selectedUsers.set([])
            rightSelected.set([])
        // }

    }
    const onRemoveParticipant = () => {
        // console.log(rightSelectedUsers.attach(Downgraded).get());
        const deletedData = rightDefaultParticipants.filter((val) => rightSelectedUsers.attach(Downgraded).get().includes(val.userID))
        let data = rightDefaultParticipants.filter(item => !rightSelectedUsers.attach(Downgraded).get().includes(item.userID));
        // console.log("deletedData",deletedData, "data",data);
        setRightDefaultParticipants(data)
        if (addsearch && addsearch.length > 0) {
            let searchAddData = rightParticipants.filter(item => !rightSelectedUsers.attach(Downgraded).get().includes(item.userID));
            // console.log("searchAddData",searchAddData);
            setRightParticipants(searchAddData)
        }
        let newR = leftParticipants;
        const newRightPart = deletedData.concat(newR)
        setResetCheckBox(true)
        // console.log("newRightPart",newRightPart,deletedData, "newR",newR);
        rightSelectedUsers.set([])
        setLeftParticipants(newRightPart)
        selectedUsers.set([])
        selected.set([]);
        setAddSearch('')
    }
    const setInviteParticipantsss = (items) => {
        // console.log("items",items);
        setRightParticipants(items)
    }
    const sortParticipants = (sort) => {
        // console.log(sort, rightParticipants, rightDefaultParticipants);
        setSortOrder(sort)
        if(sort === 'user'){
            const newParti = [...leftParticipants].filter((i) => rightDefaultParticipants && rightDefaultParticipants.length > 0 ? rightDefaultParticipants.every((j) => i.userID !== j.userID) : [...leftParticipants])
            const sorted = newParti.sort((a, b) => {
                return  a.lastName.localeCompare(b.lastName) 
              }); 
              setLeftParticipants(sorted);
        }else{
            const leftArrow = props.users.filter((i) => props.eventParticipants && props.eventParticipants.length > 0 ? props.eventParticipants.every((j) => i.userID !== j.userID) : []);
            const newParti = leftArrow.filter((i) => rightDefaultParticipants && rightDefaultParticipants.length > 0 ? rightDefaultParticipants.every((j) => i.userID !== j.userID) : [])
            setLeftParticipants(() => newParti);             
        } 
    }
    const renderDialogContent = () => (
        <>
            <Box sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                marginTop: 2,
            }}>
                <Paper sx={{ width: '48%' }}>
                    <ParticipantUserCheckList
                        data={search && search.length > 0 ? inviteParticipants : leftParticipants}
                        checkUsers={checkSelectedUsers}
                        selectedUsers={selected.attach(Downgraded).get()}
                        setInviteParticipants={setInviteParticipants}
                        setSearch={setSearch}
                        search={search}
                        onAddParticipant={onAddParticipant}
                        resetCheckBox={resetCheckBox}
                        setResetCheckBox={setResetCheckBox}
                        setLeftParticipants={setLeftParticipants}
                        sortParticipants={sortParticipants}
                        sortOrder={sortOrder}
                     />
                    <Divider />
                    <Button disabled={selectedUsers.attach(Downgraded).get().length == 0 ? true : false} sx={{ margin: 1 }} onClick={onAddParticipant} size="small" variant="outlined">Add</Button>
                </Paper>

                <Paper sx={{ width: '48%' }}>
                    <ParticipantUserAddedCheckList
                        data={addsearch && addsearch.length > 0 ? rightParticipants : rightDefaultParticipants}
                        checkUsers={rightCheckSelectedUsers}
                        selectedUsers={rightSelected.attach(Downgraded).get()}
                        setInviteParticipants={setInviteParticipantsss}
                        setAddSearch={setAddSearch}
                        addsearch={addsearch}
                        resetCheckBox={resetCheckBox}
                        setResetCheckBox={setResetCheckBox}
                    />
                    <Divider />
                    <Button disabled={rightSelectedUsers.attach(Downgraded).get().length == 0 ? true : false} sx={{ margin: 1 }} onClick={onRemoveParticipant} size="small" variant="outlined">Remove</Button>
                </Paper>
            </Box>

            <>
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={15}
                    fontWeight={700}
                    fontFamily={'Lato'}
                    noWrap
                    fontStyle="normal"
                    color='primary'
                    component="div"
                    sx={{
                        ml: 0,
                        pt: 2,
                        pb: 1,
                    }}
                >Select Role</Typography>               
                {roles.get() && roles.get().length > 0 ? (
                    <RadioGroup
                        row
                        aria-label="tripType"
                        name="userRole"
                        value={userRole.get()}
                        onChange={(event) =>
                            userRole.set(event.target.value)
                        }>
                        {roles
                            .attach(Downgraded)
                            .get()
                            .map((item, index) => {
                                return (
                                    <FormControlLabel
                                        key={`roles_${index}`}
                                        value={item.roleID}
                                        control={
                                            <Radio
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label={item.roleName}
                                    />
                                );
                            })}
                    </RadioGroup>
                ) : null}
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={15}
                    fontWeight={700}
                    fontFamily={'Lato'}
                    noWrap
                    fontStyle="normal"
                    color='primary'
                    component="div"
                    sx={{
                        ml: 0,
                        pt: 1,
                        pb: 1,
                    }}
                >Add Tags</Typography>              
                {tags.get() ? (
                    <Autocomplete
                        multiple
                        id="size-small-standard-multi"
                        size="small"
                        options={tags.attach(Downgraded).get()}
                        getOptionLabel={(option) => option.tagName}
                        value={selectedTags.attach(Downgraded).get()}
                        onChange={(event, newValue) => {
                            selectedTags.set(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Tags" />
                        )}
                    />
                ) : null}
            </>

        </>
    );
    // console.log("render how many times");
    const renderDialogActions = () => (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <ButtonContainer
                showLoading={props.showLoading}
                loading={props.showLoading}
                handleClick={handleClick}
                handleCancel={props.handleClose}
                buttonText={'Create'}
            /> 
            <Button
                variant="outlined"
                sx={{ marginTop: '16px' }}
                onClick={handleCreateAndPublished}>

                {props.showLoading ? (<> <CircularProgress /> {' Create & Published'} </>) : ' Create & Published'}
            </Button>
             
        </Box>
    );
    const saveAppNotification = (usersIds) => {
        const AppNotificationData = {
            userIDs: usersIds.toString(),
            appNotificationTypeID: 4,
            eventID: eventInfo.attach(Downgraded).get().eventID,
            moduleID: 9,
            recordRefID: eventInfo.attach(Downgraded).get().eventID,
            requestStatus: 2,
            status: 0,
            createdBy: userInfo.attach(Downgraded).get().userID,
        };
        ApiHelper.post(
            APIURLConstants.SAVE_APP_NOTIFICATION,
            AppNotificationData
        )
            .then((res) => {
                console.log('res1', res);
                usersIds.map((user) => {
                    ApiHelper.get(
                        APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                            user,
                            eventData.get().eventID,
                            eventData.get().eventName,
                            'Participant',
                            'Published'
                        )
                    ).then((res) => {
                        console.log(res);
                    });
                })

            })
            .catch((err) => {
                console.log('err', err);
            });
    };
     
    const welcomeEmail = (users, eventID, modifiedBy) => {
        if (users && users.length > 0) {
            let userIds = users.map(i => i.userID).join(',');
            let form = new FormData();
            form.append("EventID", eventID);
            form.append("UserIDs", userIds);
            form.append('ModifyBy', modifiedBy)
            ApiHelper.post(APIURLConstants.POST_WELCOME_EMAIL, form)
                .then((res) => {
                    console.log("res", res);
                })
        }
    }

    const handleClick = () => {
        (!props.enableLoader) && props.setShowLoading(true);
        if (rightDefaultParticipants.length == 0) {
            (!props.enableLoader) && props.setShowLoading(false);
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants',
            });
        } else {
            const setUserTags = selectedTags.attach(Downgraded).get();
            const setUserTagsList =
                setUserTags.length > 0
                    ? setUserTags.map((tag) => tag.tagID).join(',')
                    : '';

            let requestObj = {
                participants: [],
                userTags: setUserTagsList,
            };
            let users = rightDefaultParticipants;
            users.forEach((item) => {
                requestObj.participants.push({
                    eventUsersID: 0,
                    eventID: eventInfo.attach(Downgraded).get().eventID,
                    userID: item.userID,
                    roleID: parseInt(userRole.get() ? userRole.get() : 0),
                    createdBy: userInfo.attach(Downgraded).get().userID,
                });
            });
            ApiHelper.post(APIURLConstants.POST_EVENT_PARTICIPANTS, requestObj)
                .then((res) => {
                    if (res.data > 0) {
                        (!props.enableLoader) && props.setShowLoading(false);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants added successfully',
                        });
                        // if (eventData.get().readonlyOrHide === 0) {
                        //     saveAppNotification(users);
                        // }
                        // welcomeEmail(users.toString(),eventInfo.attach(Downgraded).get().eventID,userInfo.attach(Downgraded).get().userID)
                        props.handleClose();
                        props.getParticipants();
                        props.getAllParticipants();
                    }
                })
                .catch((error) => {
                    (!props.enableLoader) && props.setShowLoading(false);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding participant';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    // props.handleClose();
                    // props.getParticipants();
                });
            //props.handleClose();
        }
    }; 
    const handleCreateAndPublished = () => {
        (!props.enableLoader) && props.setShowLoading(true);
        if (rightDefaultParticipants.length == 0) {
            (!props.enableLoader) && props.setShowLoading(false);
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants',
            });
        } else {
            const setUserTags = selectedTags.attach(Downgraded).get();
            const setUserTagsList =
                setUserTags.length > 0
                    ? setUserTags.map((tag) => tag.tagID).join(',')
                    : '';

            let requestObj = {
                participants: [],
                userTags: setUserTagsList,
            };
            let users = rightDefaultParticipants;
            users.forEach((item) => {
                requestObj.participants.push({
                    eventUsersID: 0,
                    eventID: eventInfo.attach(Downgraded).get().eventID,
                    userID: item.userID,
                    roleID: parseInt(userRole.get() ? userRole.get() : 0),
                    createdBy: userInfo.attach(Downgraded).get().userID,
                });
            });

            ApiHelper.post(APIURLConstants.POST_EVENT_PARTICIPANTS, requestObj)
                .then((res) => {
                    if (res.data > 0) {
                        // props.setSnackBarProps({
                        //     ...props.snackBarProps,
                        //     openSnack: true,
                        //     variant: 'success',
                        //     message: 'Participants added successfully',
                        // });
                        (!props.enableLoader) && props.setShowLoading(false);
                        handlePublished(
                            requestObj,
                            eventInfo.attach(Downgraded).get().eventID,
                            userInfo.attach(Downgraded).get().userID
                        );
                        welcomeEmail(users, eventInfo.attach(Downgraded).get().eventID, userInfo.attach(Downgraded).get().userID)
                        props.handleClose();
                        props.getParticipants();
                        props.getAllParticipants();
                    }
                })
                .catch((error) => {
                    (!props.enableLoader) && props.setShowLoading(false);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while adding participant';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    // props.handleClose();
                    // props.getParticipants();
                });
            //props.handleClose();
        }
    };

    const handlePublished = (array, eventID, modifiedBy) => {
        let obj = {};
        let publishedArray = [];
        let selectedUsers = [];

        if (array.participants && array.participants.length > 0) {
            array.participants.map((row) => {
                let newObj = {};
                newObj = {
                    userID: row.userID,
                    connectionID: row.userID,
                    isPublished: true,
                    isSchedulePublished: false,
                };
                publishedArray.push(newObj);
            });
        }
        publishedArray &&
            publishedArray.map((user) => {
                if (user.isPublished === true) {
                    selectedUsers.push(user.userID);
                }
            });

        obj = {
            eventID: eventID,
            modifiedBy: modifiedBy,
            UserWiseEventPublishSetting: publishedArray,
            IsBulk: true,
            Ids: selectedUsers.join(','),
        };
        console.log(obj);

        if (obj) {
            // setLoading(true);
            ApiHelper.post(APIURLConstants.PARTICIPANT_EVENT_PUBLISHED, obj)
                .then((res) => {
                    if (res.data) {
                        // setLoading(false);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message:
                                'Participant added and  published successfully',
                        });
                        if (eventData.get().readonlyOrHide === 0) {
                            saveAppNotification(selectedUsers);
                        }
                        // setSearch('');
                        // rowsData.set(null);
                        // columnsData.set(null);
                        // filterRowsData.set(null);
                        // props.getAllData();
                        // disableButton.set(false);
                    }
                    // disableButton.set(false);
                })
                .catch((err) => {
                    if (err) {
                        // setLoading(false);
                        console.log('err : ', err);
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error in event published',
                        });
                        // disableButton.set(false);
                    }
                });
        }
    };
    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            // title={'Export Itinerary'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            dialogContentClasses={{ root: classes.dialogContentRoot }}
        />
    );
};
export default  React.memo(ParticipantUserListDialog);
